import { jsx as _jsx } from "react/jsx-runtime";
import { Alert as MuiAlert, alpha, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
const severityIcons = {
    info: 'eva:info-fill',
    warning: 'eva:alert-triangle-fill',
    error: 'eva:alert-circle-fill',
    success: 'eva:checkmark-circle-2-fill'
};
const AppAlert = ({ severity = 'info', children, icon, variant = 'outlined', sx, ...rest }) => {
    const theme = useTheme();
    const main = theme.palette[severity]?.main ?? theme.palette.info.main;
    const dark = theme.palette[severity]?.dark ?? theme.palette.info.dark;
    const defaultSx = {
        borderRadius: '14px',
        backgroundColor: alpha(main, 0.08),
        borderColor: alpha(main, 0.16),
        color: dark,
        '& .MuiAlert-icon': {
            color: main
        },
        '& .MuiAlert-action': {
            padding: 0
        }
    };
    const mergedSx = typeof sx === 'object' && sx !== null && !Array.isArray(sx)
        ? { ...defaultSx, ...sx }
        : Array.isArray(sx)
            ? [defaultSx, ...sx]
            : defaultSx;
    const defaultIcon = _jsx(Icon, { icon: severityIcons[severity] });
    return (_jsx(MuiAlert, { severity: severity, variant: variant, icon: icon ?? defaultIcon, sx: mergedSx, ...rest, children: children }));
};
export default AppAlert;
